'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showEdit = exports.showPreview = exports.isStatic = exports.isEditable = undefined;

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _overSome2 = require('lodash/overSome');

var _overSome3 = _interopRequireDefault(_overSome2);

var _overEvery2 = require('lodash/overEvery');

var _overEvery3 = _interopRequireDefault(_overEvery2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

exports.isActive = isActive;
exports.getFieldId = getFieldId;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isActive(fieldState, props) {
  return fieldState.id === props.id;
}

var isEditable = exports.isEditable = (0, _overEvery3.default)((0, _negate3.default)((0, _property3.default)('isSaving')), (0, _overSome3.default)((0, _negate3.default)((0, _property3.default)('id')), isActive));
var isStatic = exports.isStatic = (0, _negate3.default)(isEditable); // Define if we should show the (FieldView) preview text/button.

var showPreview = exports.showPreview = (0, _overSome3.default)(isStatic, (0, _property3.default)('isSaving'), (0, _negate3.default)((0, _property3.default)('isOpen'))); // When showPreview false we want to show Edit.

var showEdit = exports.showEdit = (0, _negate3.default)(showPreview);

function getFieldId(_ref) {
  var prefix = _ref.prefix,
      id = _ref.id;
  return Array.prototype.concat(prefix).concat([id]).join('-');
}